module.exports = __webpack_public_path__ + "img/loop_green.d54bc86f.svg";